module.exports = __webpack_public_path__ + "assets/img/logo-light-928a6ca3.png";